import { Injectable } from '@angular/core'
import { BehaviorSubject, from, of } from 'rxjs'
import { catchError } from 'rxjs/operators'

export interface City {
	nome: string
	codigo_uf: number
	latitude: number
	longitude: number
}

export const UF_CODE_MAP: Record<number, string> = {
	11: 'RO',
	12: 'AC',
	13: 'AM',
	14: 'RR',
	15: 'PA',
	16: 'AP',
	17: 'TO',
	21: 'MA',
	22: 'PI',
	23: 'CE',
	24: 'RN',
	25: 'PB',
	26: 'PE',
	27: 'AL',
	28: 'SE',
	29: 'BA',
	31: 'MG',
	32: 'ES',
	33: 'RJ',
	35: 'SP',
	41: 'PR',
	42: 'SC',
	43: 'RS',
	50: 'MS',
	51: 'MT',
	52: 'GO',
	53: 'DF',
}

@Injectable({ providedIn: 'root' })
export class CityService {
	private citiesSubject = new BehaviorSubject<City[]>([])
	cities$ = this.citiesSubject.asObservable()

	constructor() {
		this.loadCities()
	}

	private loadCities() {
		from(fetch('https://tagmepub.blob.core.windows.net/pubfiles/municipios.json').then(res => res.json()))
			.pipe(catchError(() => of([])))
			.subscribe((data: City[]) => this.citiesSubject.next(data))
	}

	getUfCodeMap() {
		return UF_CODE_MAP
	}

	filterCities(cities: City[], searchText: string): City[] {
		const normalizedSearch = searchText.trim().toLowerCase()
		if (normalizedSearch.length < 3) return []

		return cities.filter(
			c =>
				c.nome.toLowerCase().includes(normalizedSearch) ||
				UF_CODE_MAP[c.codigo_uf]?.toLowerCase().includes(normalizedSearch)
		)
	}
}
